






















































import Vue from "vue";
import moment from "moment";
import _ from "lodash";
import semver from "semver";

// Vue Components
import PeripheralDetailsCard from "./PeripheralDetailsCard.vue";
import BranchHistoryTimeline from "@/components/BranchHistoryTimeline.vue";

// Model
import { GetInstallationBranchHistoryCommand } from "@/model/communication/branch/GetInstallationBranchHistoryCommand";

import { InstallationStatus } from "@/model/data/status/InstallationStatus";
import VFaIcon from "@/components/VFaIcon.vue";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";

const i18nMachineStatusRoot = "device_status.machine_status_attribute";

export default Vue.extend({
    components: {
        PeripheralDetailsCard,
        BranchHistoryTimeline,
        VFaIcon,
    },
    data() {
        return {
            moment,
            loadingInstallationBranchMovingList: false,
            installationBranchMovingList: [],
        };
    },
    props: {
        installation: { type: Object as () => InstallationStatus },
        loading: { type: Boolean, required: false },
        caosBackendAddress: { type: Array, required: false },
    },
    computed: {
        machines() {
            return this.installation.machines;
        },
        statusMachines() {
            return this.installation.statusMachines;
        },
        peripherals() {
            return this.installation.peripherals;
        },
        hasAgent() {
            try {
                if (this.installation && this.installation.agentInfo && this.installation.agentInfo.version) {
                    let splittedVersion = this.installation.agentInfo.version.split(".");
                    if (splittedVersion && splittedVersion.length >= 3) return semver.gte(`${splittedVersion[0]}.${splittedVersion[1]}.${splittedVersion[2]}`, "7.1.0");
                }
            } catch {
                console.error("Cannot parse agent version");
            }
            return false;
        },
    },
    watch: {
        installation() {
            this.installationBranchMovingList = [];
            this.getInstallationBranchMovingList();
        },
    },
    methods: {
        async getInstallationBranchMovingList() {
            if (!this.loadingInstallationBranchMovingList) {
                try {
                    this.loadingInstallationBranchMovingList = true;
                    let res = await new GetInstallationBranchHistoryCommand(this.installation.name).execute();
                    this.loadingInstallationBranchMovingList = false;

                    if (res.responseStatus == ApiResponseStatusEnum.Success) {
                        this.installationBranchMovingList = _.orderBy(res.installationBranchMovingList, ["movingDateTime"], ["desc"]);
                    } else console.error("Error executing GetInstallationBranchHistoryCommand");
                } catch (e) {
                    console.error("Error executing GetInstallationBranchHistoryCommand");
                    this.loadingInstallationBranchMovingList = false;
                }
            }
        },
    },
    mounted() {
        this.getInstallationBranchMovingList();
    },
});
